import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  invoice_type: yup.number().required(),
});
